module.exports = __webpack_public_path__ + "img/asset1.529d437b.png";